export default __webpack_public_path__ + "static/fastpart-96183bbbc164e96015263fff29087723.png";